import "./Home.css";
import Services from "./Services";
import landingpageicon from "./icons/landing-page-icon.png";
import ContactUs from "./src/contact/index";
import { motion } from "framer-motion";
import { useTypewriter, Cursor } from "react-simple-typewriter";
import Parallax from "./Parallax";
import Team from "./team/Team";
import { Container } from "react-bootstrap";


const textVariants = {
  initial: {
    x: -500,
    opacity: 0,
  },
  animate: {
    x: 0,
    opacity: 1,
    transition: {
      type: "spring",
      duration: 1,
      stiffness: 100,
      damping: 9,
      staggerChildren: 0.1,
      delay: 1,
    },
  },
};

const opacityVariants = {
  initial: { opacity: 0, scale: 0.5 },
  animate: {
    opacity: 1,
    scale: 1,
    transition: {
      type: "spring",
      stiffness: 300,
      damping: 20,
      staggerChildren: 0.1,
      delay: 1,
    },
  },
};

const oppVariants = {
  initial: {
    x: 500,
    opacity: 0,
  },

  animate: {
    x: 0,
    opacity: 1,
    transition: {
      type: "spring",
      duration: 1,
      stiffness: 100,
      damping: 9,
      staggerChildren: 0.1,
      delay: 1,
    },
  },
};

function Myhomeboot() {
  const [typeEffect] = useTypewriter({
    words: ["ANIMATION", "WEB DEVELOPMENT", "ADVERTISMENT", "GRAPHIC DESIGN"],
    loop: {},
    typeSpeed: 100,
    deleteSpeed: 40,
  });
  return (
    <>
      <section
        className="p-4 pt-5 p-lg-0 pt-lg-5  text-center text-sm-start position-relative"
        id="landing-page"
      >
        <div className="container">
          <div className="d-flex align-items-center justify-content-center">
            <motion.img
              variants={textVariants}
              animate="animate"
              initial="initial"
              src={landingpageicon}
              alt=""
              className="d-block d-md-none mb-3 img-fluid w-100"
            />
          </div>
          <div
            variants={textVariants}
            className="d-sm-flex align-items-center justify-content-between text-sm-start gap-4"
            id="box"
          >
            <motion.img
              variants={textVariants}
              animate="animate"
              initial="initial"
              src="https://firebasestorage.googleapis.com/v0/b/myimages-10f37.appspot.com/o/landing-page-icon.png?alt=media&token=246e755e-b832-4684-820b-4aaa504d4864"
              alt=""
              className="img-fluid w-50 d-none d-sm-block"
              id="landing-img"
            />

            <div>
              <motion.h1
                className="display-12"
                id="heading-text"
                variants={oppVariants}
                animate="animate"
                initial="initial"
              >
                <span
                  id="dynamic-text"
                  style={{ color: "WHITE", fontWeight: "700" }}
                >
                  {" "}
                  {typeEffect}
                </span>{" "}
                <Cursor style={{ color: "red" }} />{" "}
                {/* <span
                  className="span-word"
                  style={{ display: "block", color: " white" }}
                >
                  Sungura 
                </span> */}
                <h1 className="texth1"> CREATIVES</h1>
              </motion.h1>
              <motion.div
                className="second-main-text"
                variants={oppVariants}
                animate="animate"
                initial="initial"
              >
                We are team of talented
              </motion.div>
              <motion.p
                className="paragraph-text"
                variants={oppVariants}
                animate="animate"
                initial="initial"
              >
                WEB DEVELOPERS / GRAPHIC DESIGNERS / ANIMATORS / MOTION GRAPHICS
              </motion.p>

              <motion.a
                className="mb-3"
                href="#"
                variants={opacityVariants}
                animate="animate"
                initial="initial"
              >
                {" "}
                Compare
              </motion.a>

              <motion.a
                href="#"
                variants={opacityVariants}
                animate="animate"
                initial="initial"
              >
                {" "}
                Watch Gameplay
              </motion.a>
            </div>
          </div>
        </div>
      </section>
      {/* <section>
        {" "}
        <Parallax type="services" />{" "}
      </section> */}
      <section id="section">
        <div className="container p-md-5">
          <div className="row g-4">
            <div className="col-md-6">
              <h1 className="lead" id="section2-text0">
                <b> WHAT WE DO </b>
              </h1>
              <h2 id="section2-text1">
                Creating <span>visual</span> products that exceed expectations
              </h2>
            </div>
            <div className="col-md-6">
              <h1 className="" id="section2-text2">
                Sungura Creation Kenya is a <b> multi-award-winning </b>{" "}
                creative design studio in Nairobi, Kenya focusing on{" "}
                <b>
                  Logo design, graphic design, website design, motion design,
                  brand identity, brand strategy, UI/UX design, Motion design,
                  brand Strategy, UI/UX design, and Software/ mobile App
                  development
                </b>
                . Our Clients describe us as an exceptional Studio which creates
                magnificent experiences, by delivering outstanding designs.
              </h1>
            </div>
          </div>
        </div>
      </section>
      <section
        id="animation"
        className="d-flex justify-content-center align-items-center"
        style={{
          height: "100vh",
          backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='161' height='161' viewBox='0 0 120 120'%3E%3Crect fill='orange' width='120' height='120'/%3E%3Cpolygon fill='white' fill-opacity='0.3' points='120 120 60 120 90 90 120 60 120 0 120 0 60 60 0 0 0 60 30 90 60 120 120 120' /%3E%3C/svg%3E")`,
          color: "black",
        }}
      >
        <Container id="intro">
          <div id="intro-words"
          style={{width: "40%"}}>
            <h1 style={{fontFamily: 'serif'}}>Watch our video showreel</h1>
            <p >
              We assist brands and agencies in engaging with customers by
              utilizing striking animations, motion graphics, and visual
              storytelling methods. To view a collection of our top work, please
              click the play button
            </p>
          </div>
          <iframe id="frame"
            style={{
              marginTop: '-3rem',
              height: "50vh",
              width: "100%",
              borderRadius: '2rem'
            }}
            src="https://player.vimeo.com/video/940656592?h=612f798edb&color=ffffff&portrait=0"
            width="640"
            height="360"
            frameborder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowfullscreen
          ></iframe>
        </Container>
      </section>
      <section id="services">
        {" "}
        <Services />
      </section>
      <section id="parallaxx">
        {" "}
        <Parallax />{" "}
      </section>
      <section
        id="team"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='161' height='161' viewBox='0 0 120 120'%3E%3Crect fill='orange' width='120' height='120'/%3E%3Cpolygon fill='grey' fill-opacity='0.5' points='120 120 60 120 90 90 120 60 120 0 120 0 60 60 0 0 0 60 30 90 60 120 120 120' /%3E%3C/svg%3E")`,
          color: "black",
        }}
      >
        <Team />
      </section>
      <section id="contact-us">
        {" "}
        <ContactUs />
      </section>
    </>
  );
}
export default Myhomeboot;
